import Utils from 'services/utils';

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * NotesApi class.
 */
export default class NotesApi {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    constructor($http) {
        this.$http = $http;
        this.listUrl = Utils.buildApiUrl('notes.list');
    }

    /**
     * Get Notes
     * @returns {promise}
     */
    getList() {
        return this.$http.get(this.listUrl).then(responseDataExtractor);
    }

    /**
     * Get Notes by Object id
     * @param {Object} params - consist from 'object_id', 'page_size', 'page_token'
     * @returns {promise}
     */
    getListByObject(params) {
        return this.$http
            .get(this.listUrl, {
                params
            }).then(responseDataExtractor);
    }

    /**
     * Create note
     * @param {Object} note - Note object
     * @returns {promise}
     */
    createNote(note) {
        return this.$http.post(this.listUrl, { ...note }).then(responseDataExtractor);
    }

    /**
     * Edit Note
     * @param {Number} noteId - Note id
     * @param {String} content - Note content
     * @returns {promise}
     */
    editNote(noteId, content) {
        const url = Utils.buildApiUrl('notes.entity', { noteId });
        return this.$http.put(url, { content }).then(responseDataExtractor);
    }


    /**
     * Delete note by given id
     * @param {number} noteId - Note id
     * @returns {promise}
     */
    deleteNote(noteId) {
        const url = Utils.buildApiUrl('notes.entity', { noteId });

        return this.$http.delete(url).then(responseDataExtractor);
    }
}



// WEBPACK FOOTER //
// ./app/services/api/notes/notes.service.js